// https://firebase.google.com/docs/emulator-suite/connect_firestore#android_apple_platforms_and_web_sdks
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
// https://firebase.google.com/docs/functions/local-emulator#instrument-functions
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";

const firebase = initializeApp({
  projectId: "tvmision-e9656",
  appId: "1:76012993386:ios:f49c6ee6ad1d5183a1c313",
  storageBucket: "tvmision-e9656.appspot.com",
  apiKey: "AIzaSyCdr2xavUp0__oxjQxCtryuVu1BqGC1-Qc",
  authDomain: "76012993386-73nlm6br3j1sr7mgg0n9qiohhvo3vjaa.apps.googleusercontent.com",
  messagingSenderId: "76012993386",
});
const functions = getFunctions(firebase);
const firestore = getFirestore(firebase);
const auth = getAuth(firebase);

// if (window.location.hostname === "localhost") {
//   console.log(
//     "Testing locally: hitting local functions and firestore emulators."
//   );
//   connectFunctionsEmulator(functions, "127.0.0.1", 5001);
//   connectFirestoreEmulator(firestore, "127.0.0.1", 8080);
// }

export { functions, firestore, auth };